/* global window:true, document:true */

import { BrowsingContextError } from '../../browsingContextError';

export function getGlobalWindow(): Window | undefined {
  return typeof window !== 'undefined' ? window : undefined;
}

export function getGlobalWindowOrThrow(): Window {
  const window = getGlobalWindow();
  if (!window) {
    throw new BrowsingContextError();
  }

  return window;
}

export function getGlobalDocument(): Document | undefined {
  return typeof document !== 'undefined' ? document : undefined;
}
